module.exports = __webpack_public_path__ + "img/img_tisu@2x.2f6173bf.png";